import { Box, Checkbox, colors, FormControlLabel, TextField, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { AuthContext } from '../utils/AuthContext';
import {
  CGHO_INSURER_ID, reuploadRates, reuploadRatesCGHO, updateRates, updateRatesCGHO, uploadNewRates, uploadNewRatesCGHO
} from '../services/InsurerRateService';

export default function RatesFormDialog({ open, setOpen, selectedId, selectedTitle,
  setIsFileUploading, handleFetchInsurerRates, mode, insurerRate }) {
  const { auth, setAuth } = useContext(AuthContext);

  const [file, setFile] = useState(null);

  const [version, setVersion] = useState('');
  const [isLatest, setLatest] = useState(false);

  useEffect(() => {
    if (mode === 'update' || mode === 'reupload') {
      setVersion(insurerRate.version);
      setLatest(insurerRate.is_latest);
    }
    
  }, [mode, insurerRate]);

  function handleUploadFile() {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('insurer', selectedId);
    formData.append('version', version);

    setOpen(false);
    setIsFileUploading(true);

    const toastId = toast.loading("Uploading...");

    const uploadFn = selectedId === CGHO_INSURER_ID ? uploadNewRatesCGHO : uploadNewRates;

    uploadFn({ body: formData, token: auth.token }).then(() => {
      toast.update(toastId, {
        type: 'success',
        render: selectedTitle + ' Uploaded',
        autoClose: 2500,
        closeButton: true,
        hideProgressBar: true,
        isLoading: false
      });

      setIsFileUploading(false);

      handleFetchInsurerRates();
    })
      .catch(err => {
        setIsFileUploading(false);
      });
  }

  function handleReUploadFile() {
    const formData = new FormData();
    formData.append('file', file);

    setOpen(false);
    setIsFileUploading(true);

    const toastId = toast.loading("Uploading...");

    const reuploadFn = selectedId === CGHO_INSURER_ID ? reuploadRatesCGHO : reuploadRates;

    reuploadFn({ body: formData, token: auth.token, insurerRateId: insurerRate.id }).then(() => {
      toast.update(toastId, {
        type: 'success',
        render: selectedTitle + ' Re-Uploaded',
        autoClose: 2500,
        closeButton: true,
        hideProgressBar: true,
        isLoading: false
      });

      setIsFileUploading(false);

      handleFetchInsurerRates();
    })
      .catch(err => {
        setIsFileUploading(false);
      });
  }

  function handleUpdate() {
    const formData = new FormData();
    formData.append('version', version);
    formData.append('is_latest', isLatest);

    setOpen(false);
    setIsFileUploading(true);

    const toastId = toast.loading("Updating...");

    const updateFn = selectedId === CGHO_INSURER_ID ? updateRatesCGHO : updateRates;

    updateFn({ id: insurerRate.id, body: formData, token: auth.token }).then(() => {
      toast.update(toastId, {
        type: 'success',
        render: selectedTitle + ' Updated',
        autoClose: 2500,
        closeButton: true,
        hideProgressBar: true,
        isLoading: false
      });

      setIsFileUploading(false);

      handleFetchInsurerRates();
    })
      .catch(err => {
        setIsFileUploading(false);
      });
  }

  function handleSubmit() {
    if (mode === 'add') {
      handleUploadFile();
    } else if (mode === 'update') {
      handleUpdate();
    } else if (mode === 'reupload') {
      handleReUploadFile();
    }
    
  }

  const handleClose = () => {
    setOpen(false);
  };

  function getTitle() {
    if (mode === 'add') {
      return 'Upload New Rates';
    } else if (mode === 'update') {
      return 'Update Rates';
    } else if (mode === 'reupload') {
      return 'Reupload Rates';
    }
  }

  function getPositiveButtonLabel() {
    if (mode === 'add') {
      return 'Upload';
    } else if (mode === 'update') {
      return 'Submit';
    } else if (mode === 'reupload') {
      return 'Reupload';
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title">
        {getTitle()}
      </DialogTitle>
      <DialogContent>
        <Box minWidth={500}>
          <Box sx={{ display: 'flex' }}>
            <Typography sx={{ mr: 1, fontSize: 16 }}>
              Type:
            </Typography>
            <Typography sx={{ fontSize: 16, color: colors.blue[700], fontWeight: 600 }}>{selectedTitle}</Typography>
          </Box>
          {
            (mode === 'add' || mode === 'reupload') && <Box sx={{ mt: 2 }}>
              <input type='file' onChange={(e) => {
                setFile(e.target.files[0]);
              }} />
            </Box>
          }

          <Box sx={{ mt: 2, }}>
            <TextField disabled={mode === 'reupload'} value={version} onChange={(e) => { setVersion(e.target.value) }} size='small' label='Version Name' fullWidth />
          </Box>
          {
            mode === 'update' &&
            <Box sx={{ mt: 1 }}>
              <FormControlLabel control={<Checkbox checked={isLatest} onChange={(e) => {
                setLatest(e.target.checked);
              }} />} label="Latest Version" />
            </Box>
          }

        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button autoFocus onClick={handleSubmit}>
          {getPositiveButtonLabel()}
        </Button>
      </DialogActions>
    </Dialog>
  );
}